// @flow
import React from 'react';

type Props = {
  title: string,
  value: number,
};

const Score = (props: Props) => {
  const { title, value } = props;
  return (
    <p className="c-score" data-value={value} data-title={title}>
      <span className="c-label">{title}</span>
      <span className="c-score__value">
        <div
          className="c-score__fill"
          style={{ height: '100%', width: `${value}%` }}
        />
      </span>
    </p>
  );
};

export default Score;
